import type { MonetizingApi } from '@openx/types/monetizing';

export const areMonetizingDifferent = (
  previousMonetizing: MonetizingApi | undefined,
  actualMonetizing: MonetizingApi | undefined
): boolean => {
  // Early exit for same reference
  if (previousMonetizing === actualMonetizing) {
    return false;
  }

  // Check if one is undefined and the other isn't
  if ((!previousMonetizing && !!actualMonetizing) || (!actualMonetizing && !!previousMonetizing)) {
    return false;
  }

  // Both are undefined
  if (!previousMonetizing && !actualMonetizing) {
    return false;
  }

  // Compare each field and return true on first difference
  if (previousMonetizing?.id !== actualMonetizing?.id) {
    return true;
  }

  if (previousMonetizing?.uid !== actualMonetizing?.uid) {
    return true;
  }

  if (previousMonetizing?.account_uid !== actualMonetizing?.account_uid) {
    return true;
  }

  if (previousMonetizing?.pacing_mode !== actualMonetizing?.pacing_mode) {
    return true;
  }

  if (previousMonetizing?.flight_start !== actualMonetizing?.flight_start) {
    return true;
  }

  if (previousMonetizing?.flight_end !== actualMonetizing?.flight_end) {
    return true;
  }

  if (previousMonetizing?.region !== actualMonetizing?.region) {
    return true;
  }

  if (previousMonetizing?.budget_type !== actualMonetizing?.budget_type) {
    return true;
  }

  if (previousMonetizing?.budget !== actualMonetizing?.budget) {
    return true;
  }

  if (!!previousMonetizing?.['cadences'] !== !!actualMonetizing?.['cadences']) {
    return true;
  }

  if (previousMonetizing?.['cadences']?.type !== actualMonetizing?.['cadences']?.type) {
    return true;
  }

  if (previousMonetizing?.['cadences']?.budget !== actualMonetizing?.['cadences']?.budget) {
    return true;
  }

  return false;
};
